import './styles.scss';

import React, { useEffect, useState } from 'react';
import { Flex, Loader } from '@gjensidige/builders-components';
import { IllustrationType } from '@gjensidige/se-content-helpers';

import tracker from './tracking';
import { InputWidgetContainer } from './containers/InputWidgetContainer';
import { AppHelper } from './utils/AppHelper';

interface AppProps {
  additionalDataUrl?: string | null;
  additionalDataObject?: string | null;
}

export const App: React.FC<AppProps> = (props: AppProps) => {
  let cdnTexts = {
    headerText: '',
    imageAltText: '',
    regNumberLabel: '',
    regNumberPlaceHolder: '',
    cprNumberLabel: '',
    cprNumberPlaceHolder: '',
    cprNumberHelpText: '',
    calculateBtnLabel: '',
    footerMessage: ''
  };
  const enonicDataDefault = {
    ...cdnTexts,
    imageLocations: {
      image: '',
      smallScreenImage: '',
      regPlateImage: ''
    }
  };
  const [isReady, setIsReady] = useState(false);
  const [cdnData, setCdnData] = useState(enonicDataDefault);
  // let imageLocations = {
  //   image: '',
  //   smallScreenImage: '',
  //   regPlateImage: ''
  // };
  let IMAGE_FILE_NAME = 'ColleaguesTalking';
  let IMAGE_FILE_NAME_SMALL_SCREEN = 'ColleaguesTalkingSmallScreen';
  const REG_PLATE_FILE_NAME = 'LicensePlateNCI';
  //const [imageUrls, setImageUrls] = useState(imageLocations);

  useEffect(() => {
    const getInitialdata = async () => {
      await AppHelper.fetchInitialData();
      if (props.additionalDataUrl || props.additionalDataObject) {
        const enonicData = await AppHelper.getEnonicContent(
          props.additionalDataUrl || '',
          props.additionalDataObject || ''
        );
        cdnTexts = {
          headerText: enonicData?.headerText || '',
          imageAltText: enonicData?.imageAltText || '',
          regNumberLabel: enonicData?.regNumberLabel || '',
          regNumberPlaceHolder: enonicData?.regNumberPlaceHolder || '',
          cprNumberLabel: enonicData?.cprNumberLabel || '',
          cprNumberPlaceHolder: enonicData?.cprNumberPlaceHolder || '',
          cprNumberHelpText: enonicData?.cprNumberHelpText || '',
          calculateBtnLabel: enonicData?.calculateBtnLabel || '',
          footerMessage: enonicData?.footerMessage || ''
        };
        IMAGE_FILE_NAME = enonicData?.imageFileName
          ? enonicData.imageFileName
          : IMAGE_FILE_NAME;
        IMAGE_FILE_NAME_SMALL_SCREEN = enonicData?.smallScreenImageFileName
          ? enonicData.smallScreenImageFileName
          : IMAGE_FILE_NAME_SMALL_SCREEN;
      }

      if (AppHelper.AppIllustrations.length) {
        const carImageURL = await AppHelper.fetchImageUrl(
          IMAGE_FILE_NAME,
          IllustrationType.SIMPLE
        );
        const carImageSmallScreenUrl = await AppHelper.fetchImageUrl(
          IMAGE_FILE_NAME_SMALL_SCREEN,
          IllustrationType.SIMPLE
        );
        const registrationPlateImage = await AppHelper.fetchImageUrl(
          REG_PLATE_FILE_NAME,
          IllustrationType.SIMPLE
        );
        const imageLocations = {
          image: carImageURL || '',
          smallScreenImage: carImageSmallScreenUrl || '',
          regPlateImage: registrationPlateImage || ''
        };
        setCdnData({
          ...cdnTexts,
          imageLocations
        });
        setIsReady(true);
      }
    };
    getInitialdata();
    trackPartsView();
  }, []);

  const trackPartsView = () => {
    tracker.trackEvent({
      eventLabel: 'webshop_company_car_widget',
      eventAction: 'impression',
      eventCategory: 'impression',
      eventModule: 'webshop'
    });
  };

  return (
    <div className="app-container">
      <Flex justify="center">
        {isReady ? (
          <InputWidgetContainer enonicData={cdnData} />
        ) : (
          <Loader size="lg" variant="spinner" />
        )}
      </Flex>
    </div>
  );
};
